import { render } from "./StudentPageHeading.vue?vue&type=template&id=a94d09fe&ts=true"
import script from "./StudentPageHeading.vue?vue&type=script&lang=ts"
export * from "./StudentPageHeading.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__